const ROLES = {
  User: 2001,
  Team: 1984,
  Admin: 5150,
};

export default ROLES;
